<dl class="leading-fields">
  <div>
    <dt>{{ 'Common' | translate }}:</dt>
    <dd>{{ certificate.common || '--' }}</dd>
  </div>
  <div>
    <dt>{{ 'SAN' | translate }}:</dt>
    <dd>{{ certificate.san?.join(', ') }}</dd>
  </div>
  <div>
    <dt>{{ 'Distinguished Name' | translate }}:</dt>
    <dd>{{ certificate.DN || '--' }}</dd>
  </div>
</dl>

<div class="columns attributes">
  <dl class="column">
    <div>
      <dt>{{ 'Country' | translate }}:</dt>
      <dd>{{ certificate.country || '--' }}</dd>
    </div>
    <div>
      <dt>{{ 'State' | translate }}:</dt>
      <dd>{{ certificate.state || '--' }}</dd>
    </div>
    <div>
      <dt>{{ 'City' | translate }}:</dt>
      <dd>{{ certificate.city || '--' }}</dd>
    </div>
  </dl>
  <dl class="column">
    <div>
      <dt>{{ 'Organization' | translate }}:</dt>
      <dd>{{ certificate.organization || '--' }}</dd>
    </div>
    <div>
      <dt>{{ 'Organizational Unit' | translate }}:</dt>
      <dd>{{ certificate.organizational_unit || '--' }}</dd>
    </div>
    <div>
      <dt>{{ 'Email' | translate }}:</dt>
      <dd>{{ certificate.email || '--' }}</dd>
    </div>
  </dl>
</div>

<div class="columns">
  <dl class="column">
    <div>
      <dt>{{ 'Type' | translate }}:</dt>
      <dd>{{ certificate.cert_type }}</dd>
    </div>
    <div>
      <dt>{{ 'Path' | translate }}:</dt>
      <dd>{{ certificate.root_path }}</dd>
    </div>
    <div>
      <dt>{{ 'Digest Algorithm' | translate }}:</dt>
      <dd>{{ certificate.digest_algorithm }}</dd>
    </div>
    <div>
      <dt>{{ 'Key Length' | translate }}:</dt>
      <dd>{{ certificate.key_length }}</dd>
    </div>
    <div>
      <dt>{{ 'Key Type' | translate }}:</dt>
      <dd>{{ certificate.key_type }}</dd>
    </div>
  </dl>
  <dl class="column">
    <div>
      <dt>{{ 'Until' | translate }}:</dt>
      <dd>{{ certificate.until }}</dd>
    </div>
    <div>
      <dt>{{ 'Issuer' | translate }}:</dt>
      <dd>{{ issuer }}</dd>
    </div>
    <div>
      <dt>{{ 'Revoked' | translate }}:</dt>
      <dd>{{ certificate.revoked }}</dd>
    </div>
    <div *ngIf="showSignedBy; else signedCertificatesItem">
      <dt>{{ 'Signed By' | translate }}:</dt>
      <dd>{{ certificate.signedby?.name || '--' }}</dd>
    </div>
    <ng-template #signedCertificatesItem>
      <div>
        <dt>{{ 'Signed Certificates' | translate }}:</dt>
        <dd>{{ signedCertificates }}</dd>
      </div>
    </ng-template>
    <div>
      <dt>{{ 'Lifetime' | translate }}:</dt>
      <dd>{{ certificate.lifetime }}</dd>
    </div>
  </dl>
</div>
